/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Button, Checkbox, CircularProgress, FormControl, InputLabel, OutlinedInput, styled, TextField, Tooltip, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import { apiRequest } from "../../../../common/common";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { ActionStage, ArchitecturalCode, FundingSource, ItemStatus, ProductType, Responsibility } from "../../../../common/const";
import moment from "moment";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;


const CustomFilterPanelWrapper = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: 10,
});

// The content area where filter controls will go
const FilterContent = styled(Box)({
    flexGrow: 1,         // Take up available space
    overflowY: 'auto',   // Enable scrolling if content overflows
    paddingBottom: 30,   // Ensure space for the fixed footer
});

// Footer area with fixed button
const FilterFooter = styled(Box)({
    position: 'sticky',
    bottom: 0,
    display: 'flex',
    gap: 5
});

// Fixed button in the footer
const FixedButton = styled(Button)({
    width: '100%',
});

export default function FilterPanel({
    projectId,
    applyFilter
}) {
    const [expanded, setExpanded] = useState(false);
    const [filters, setFilters] = useState(localStorage.getItem('itemfilters') ? JSON.parse(localStorage.getItem('itemfilters')) : {});
    const [vendorLoading, setVendorLoading] = useState(false);
    const [vendorData, setVendorData] = useState([]);
    const [isVendorAvailable, setIsVendorAvailable] = useState(false);
    const [vendorPage, setVendorPage] = useState(1);
    const [inputValue, setInputValue] = useState('');
    const [manufacturerData, setManufacturerData] = useState([]);
    const [manufacturerPage, setManufacturerPage] = useState(1);
    const [isManufacturerAvailable, setIsManufacturerAvailable] = useState(true);
    const [manufacturerLoading, setManufacturerLoading] = useState(false);
    const [manInputValue, setManInputValue] = useState('');
    const [categoryData, setCategoryData] = useState([]);
    const [categoryPage, setCategoryPage] = useState(1);
    const [isCategoryAvailable, setIsCategoryAvailable] = useState(true);
    const [categoryLoading, setCategoryLoading] = useState(false);
    const [subCategoryData, setSubCategoryData] = useState([]);
    const [subCategoryPage, setSubCategoryPage] = useState(1);
    const [isSubCategoryAvailable, setIsSubCategoryAvailable] = useState(true);
    const [subCategoryLoading, setSubCategoryLoading] = useState(false);
    const [categoryInput, setCategoryInput] = useState('');
    const [budgetLoading, setBudgetLoading] = useState(false);
    const [budgetData, setBudgetData] = useState([]);
    const [depData, setDepData] = useState([]);
    const [roomData, setRoomData] = useState([]);
    const [dataLoading, setDataLoading] = useState(false);

    const getSubCategoryData = async (categoryIds, pageNo) => {
        try {
            setSubCategoryLoading(true);
            const response = await apiRequest('get', `/category/list?parentId=${categoryIds.toString()}&pageNo=${pageNo}&pageSize=100&type=subCategory`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsSubCategoryAvailable(true);
                let array = [];
                array = [...subCategoryData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setSubCategoryData(uniqueArray);
                setSubCategoryLoading(false);
            } else {
                setIsSubCategoryAvailable(false);
                setSubCategoryLoading(false);
            }
        } catch (error) {
            setSubCategoryLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getCategoryData = async (pageNo, searchText) => {
        try {
            setCategoryLoading(true);
            const response = await apiRequest('get', `/category/list?pageNo=${pageNo}&pageSize=100&type=category&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsCategoryAvailable(true);
                const array = [...categoryData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setCategoryData(uniqueArray);
                setCategoryLoading(false);
            } else {
                setIsCategoryAvailable(false);
                setCategoryLoading(false);
            }
        } catch (error) {
            setCategoryLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const loadNextCategory = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = categoryPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isCategoryAvailable) {
            setCategoryPage(numberOfPages);
            await getCategoryData(numberOfPages);
        }
    };

    const loadNextSubCategory = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = subCategoryPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isSubCategoryAvailable) {
            setSubCategoryPage(numberOfPages);
            await getSubCategoryData(filters?.category, numberOfPages);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            if (filters?.category?.length > 0) {
                await getSubCategoryData(filters?.category, subCategoryPage);
            }
        }
        fetchData();
    }, [filters?.category]);

    const getVendorData = async (pageNo, searchText) => {
        try {
            setVendorLoading(true);
            const response = await apiRequest('get', `/product-provider?type=vender&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsVendorAvailable(true);
                const array = [...vendorData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setVendorData(uniqueArray);
                setVendorLoading(false);
            } else {
                setIsVendorAvailable(false);
                setVendorLoading(false);
            }
        } catch (error) {
            setVendorLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const loadNextVendor = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = vendorPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isVendorAvailable) {
            setVendorPage(numberOfPages);
            await getVendorData(numberOfPages);
        }
    };

    const getManufacturerData = async (pageNo, searchText) => {
        try {
            setManufacturerLoading(true);
            const response = await apiRequest('get', `/product-provider?type=manufacturer&pageNo=${pageNo}&pageSize=100&${searchText ? `searchText=${searchText}` : ''}`);
            const { data } = response.data;
            if (data?.length > 0) {
                setIsManufacturerAvailable(true);
                const array = [...manufacturerData, ...data];
                const uniqueArray = [
                    ...new Set(
                        array.map((item) => JSON.stringify(item)),
                    ),
                ].map((item) => JSON.parse(item));
                setManufacturerData(uniqueArray);
                setManufacturerLoading(false);
            } else {
                setIsManufacturerAvailable(false);
                setManufacturerLoading(false);
            }
        } catch (error) {
            setManufacturerLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const loadNextManufacturer = async (event) => {
        const listBoxNode = event.currentTarget;
        const numberOfPages = manufacturerPage + 1;
        const position = listBoxNode.scrollTop + listBoxNode.clientHeight;
        if (listBoxNode.scrollHeight - position <= 1 && isManufacturerAvailable) {
            setManufacturerPage(numberOfPages);
            await getManufacturerData(numberOfPages);
        }
    };

    const getBudgetData = async () => {
        try {
            setBudgetLoading(true);
            const response = await apiRequest('get', `/budget?projectId=${projectId}&pageNo=1&pageSize=100`);
            const { data } = response.data;
            if (data?.length > 0) {
                setBudgetData(data);
            }
            setBudgetLoading(false);
        } catch (error) {
            setBudgetLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }


    const getRooms = async () => {
        const url = [
            `/project-room?projectId=${projectId}`,
            filters?.departmentids?.length > 0 ? `&departmentIds=${filters?.departmentids}` : '',
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setRoomData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const getDepartment = async () => {
        const url = [
            `/department?projectId=${projectId}`,
            `pageNo=1`,
            `pageSize=100`,
        ].filter(Boolean).join('&');
        try {
            const response = await apiRequest('get', `${url}`);
            const { data } = response.data;
            setDepData(data);
            setDataLoading(false);
        } catch (error) {
            setDataLoading(false);
            showNotification(error?.response?.data.error || error.message, 'error');
        }
    }

    const handleChange = (panel) => (event, isExpanded) => {
        if (panel === 'panel1' && isExpanded) {
            const obj = filters;
            if (!obj?.altId) {
                obj.altId = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel2' && isExpanded) {
            const obj = filters;
            if (!obj?.archCode) {
                obj.archCode = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel3' && isExpanded) {
            const obj = filters;
            if (!obj?.architecturally) {
                obj.architecturally = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel4' && isExpanded) {
            getBudgetData();
            const obj = filters;
            if (!obj?.budgetids) {
                obj.budgetids = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel5' && isExpanded) {
            getCategoryData(categoryPage);
            const obj = filters;
            if (!obj?.category) {
                obj.category = [];
            }
            if (!obj?.subCategory) {
                obj.subCategory = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel6' && isExpanded) {
            const obj = filters;
            if (!obj?.discontinued) {
                obj.discontinued = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel7' && isExpanded) {
            const obj = filters;
            if (!obj?.notes) {
                obj.notes = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel8' && isExpanded) {
            const obj = filters;
            if (!obj?.startdate) {
                obj.startdate = null;
            }
            if (!obj?.enddate) {
                obj.enddate = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel9' && isExpanded) {
            const obj = filters;
            if (!obj?.fundingSource) {
                obj.fundingSource = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel10' && isExpanded) {
            getManufacturerData(manufacturerPage);
            const obj = filters;
            if (!obj?.manufacturer) {
                obj.manufacturer = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel11' && isExpanded) {
            const obj = filters;
            if (!obj?.furnish) {
                obj.furnish = [];
            }
            if (!obj?.install) {
                obj.install = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel12' && isExpanded) {
            const obj = filters;
            if (!obj?.spatially) {
                obj.spatially = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel13' && isExpanded) {
            const obj = filters;
            if (!obj?.stage) {
                obj.stage = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel14' && isExpanded) {
            const obj = filters;
            if (!obj?.status) {
                obj.status = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel15' && isExpanded) {
            const obj = filters;
            if (!obj?.productType) {
                obj.productType = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel16' && isExpanded) {
            getVendorData(vendorPage);
            const obj = filters;
            if (!obj?.vendors) {
                obj.vendors = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel17' && isExpanded) {
            const obj = filters;
            if (!obj?.inventoryid) {
                obj.inventoryid = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel18' && isExpanded) {
            const obj = filters;
            if (!obj?.isDeleted) {
                obj.isDeleted = null;
            }
            setFilters(obj);
        }
        if (panel === 'panel19' && isExpanded) {
            getDepartment();
            const obj = filters;
            if (!obj?.departmentids) {
                obj.departmentids = [];
            }
            setFilters(obj);
        }
        if (panel === 'panel20' && isExpanded) {
            getRooms();
            const obj = filters;
            if (!obj?.roomids) {
                obj.roomids = [];
            }
            setFilters(obj);
        }
        setExpanded(isExpanded ? panel : false);
    };

    const handleFilter = async () => {
        if (filters?.altId === null) {
            showNotification('Please select Alternate ID Option', 'error');
        } else if (filters?.archCode?.length === 0) {
            showNotification('Please select Architectural Code', 'error');
        } else if (filters?.architecturally === null) {
            showNotification('Please select Architecturally Significant Option', 'error');
        } else if (filters?.budgetids?.length === 0) {
            showNotification('Please select Budget', 'error');
        } else if (filters?.category?.length === 0 && filters?.subCategory?.length === 0) {
            showNotification('Please select category or subcategory', 'error');
        } else if (filters?.discontinued === null) {
            showNotification('Please select Disconutinued option', 'error');
        } else if (filters?.notes === null) {
            showNotification('Please select Notes option', 'error');
        } else if (filters?.fundingSource?.length === 0) {
            showNotification('Please select Funding Source', 'error');
        } else if (filters?.manufacturer?.length === 0) {
            showNotification('Please select manufacturer', 'error');
        } else if (filters?.furnish?.length === 0) {
            showNotification('Please select Furnish Responsibility', 'error');
        } else if (filters?.install?.length === 0) {
            showNotification('Please select Install Responsibility', 'error');
        } else if (filters?.spatially === null) {
            showNotification('Please select Spatially Significant Option', 'error');
        } else if (filters?.stage?.length === 0) {
            showNotification('Please select Stage', 'error');
        } else if (filters?.status?.length === 0) {
            showNotification('Please select Status', 'error');
        } else if (filters?.productType?.length === 0) {
            showNotification('Please select Type', 'error');
        } else if (filters?.vendor?.length === 0) {
            showNotification('Please select vendor', 'error');
        } else if (filters?.inventoryid === null) {
            showNotification('Please select Inventory ID Option', 'error');
        } else if (Object.keys(filters).length === 0) {
            showNotification('Please select any field before apply filter', 'error');
        } else if (filters?.startdate === null || filters?.enddate === null) {
            showNotification('Please select Need By Date', 'error');
        } else {
            setExpanded(false);
            await applyFilter(filters);
        }
    }

    useEffect(() => {
        if (filters.length > 0) {
            if (filters.find((a) => a.field === 'department_id')) {
                getRooms();
            }
        }
    }, [filters]);

    return (
        <CustomFilterPanelWrapper>
            <Typography variant="body1" style={{ fontWeight: 'bold' }}>Filters</Typography>
            <FilterContent>
                <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel1-content"
                        id="panel1-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.altId && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Alternate ID</Typography>
                            </Box>
                            {expanded === 'panel1' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.altId;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.altId === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        altId: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.altId === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        altId: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel2-content"
                        id="panel2-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.archCode?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Architectural Code</Typography>
                            </Box>
                            {expanded === 'panel2' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.archCode;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={ArchitecturalCode.filter((c) => filters?.archCode?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={ArchitecturalCode}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    archCode: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Architectural Code"
                                    name="Architectural Code"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel3-content"
                        id="panel3-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.architecturally && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Architecturally Significant</Typography>
                            </Box>
                            {expanded === 'panel3' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.architecturally;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.architecturally === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        architecturally: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.architecturally === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        architecturally: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel4'} onChange={handleChange('panel4')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel4-content"
                        id="panel4-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.budgetids?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Budget</Typography>
                            </Box>
                            {expanded === 'panel4' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.budgetids;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={budgetData.filter((c) => filters?.budgetids?.includes(c.budget_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={budgetData}
                            getOptionLabel={(option) => option?.budget_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.budget_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    budgetids: newValue.map((a) => a.budget_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Budget"
                                    name="Budget"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {budgetLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel19'} onChange={handleChange('panel19')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel19-content"
                        id="panel19-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.departmentids?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Departments</Typography>
                            </Box>
                            {expanded === 'panel19' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.departmentids;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={depData.filter((c) => filters?.departmentids?.includes(c.department_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={depData}
                            getOptionLabel={(option) => option?.department_name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.department_name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    departmentids: newValue.map((a) => a.department_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Department"
                                    name="Department"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {dataLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel20'} onChange={handleChange('panel20')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel20-content"
                        id="panel20-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.roomids?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Rooms</Typography>
                            </Box>
                            {expanded === 'panel20' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.roomids;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={roomData.filter((c) => filters?.roomids?.includes(c.room_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={roomData}
                            getOptionLabel={(option) => `${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {`${option?.room_name} ${option.room_no ? `(${option.room_no})` : ''}`}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    roomids: newValue.map((a) => a.room_id),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Room"
                                    name="Room"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {dataLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel5'} onChange={handleChange('panel5')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel5-content"
                        id="panel5-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.category?.length > 0 || filters?.subCategory?.length > 0) && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Categories</Typography>
                            </Box>
                            {expanded === 'panel5' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.category;
                                            delete obj.subCategory;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={categoryData.filter((c) => filters?.category?.includes(c?.category_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={categoryData}
                            getOptionLabel={(option) => option?.name}
                            ListboxProps={{
                                onScroll: (event) => loadNextCategory(event),
                            }}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    category: newValue?.map((a) => a.category_id)
                                }));
                                setSubCategoryData([]);
                                setSubCategoryPage(1);
                                setCategoryPage(1);
                            }}
                            inputValue={categoryInput === 0 || categoryInput === 'on' ? '' : categoryInput}
                            onInputChange={(e) => {
                                if (e) {
                                    setCategoryInput(e.target.value);
                                    if (e?.target?.value?.length >= 1) {
                                        getCategoryData(1, e?.target?.value);
                                    }
                                    setSubCategoryPage(1);
                                    setCategoryPage(1);
                                }
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Categories"
                                    name="Categories"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {categoryLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                        <br />
                        <Autocomplete
                            value={subCategoryData?.filter((c) => filters?.subCategory?.includes(c.category_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={subCategoryData}
                            getOptionLabel={(option) => `${option?.name} (${option?.parent?.name})`}
                            ListboxProps={{
                                onScroll: (event) => loadNextSubCategory(event),
                            }}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {`${option?.name} (${option?.parent?.name})`}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    subCategory: newValue?.map((a) => a.category_id)
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Subcategories"
                                    name="Subcategories"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {subCategoryLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel6'} onChange={handleChange('panel6')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel6-content"
                        id="panel6-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.discontinued && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Discontinued</Typography>
                            </Box>
                            {expanded === 'panel6' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.discontinued;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.discontinued === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        discontinued: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.discontinued === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        discontinued: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel7'} onChange={handleChange('panel7')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel7-content"
                        id="panel7-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.notes && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Notes</Typography>
                            </Box>
                            {expanded === 'panel7' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.notes;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.notes === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        notes: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.notes === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        notes: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel8'} onChange={handleChange('panel8')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel8-content"
                        id="panel8-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.startdate && filters?.enddate) && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Need By Date</Typography>
                            </Box>
                            {expanded === 'panel8' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.startdate;
                                            delete obj.enddate;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password" shrink={filters?.startdate === null || filters?.startdate === '' || filters?.startdate}>Date 1</InputLabel>
                            <OutlinedInput
                                label="Date 1"
                                id="Date 1"
                                type='date'
                                value={filters?.startdate || ''}
                                onChange={(e) => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        startdate: moment(e.target.value).format('YYYY-MM-DD') || null,
                                    }));
                                }}
                            />
                        </FormControl>
                        <FormControl size="small" fullWidth variant="outlined" style={{ marginTop: 15 }}>
                            <InputLabel htmlFor="standard-adornment-password" shrink={filters?.enddate === null || filters?.enddate === '' || filters?.enddate}>Date 2</InputLabel>
                            <OutlinedInput
                                label="Date 2"
                                id="Date 2"
                                type='date'
                                value={filters?.enddate || ''}
                                onChange={(e) => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        enddate: moment(e.target.value).format('YYYY-MM-DD') || null,
                                    }));
                                }}
                            />
                        </FormControl>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel9'} onChange={handleChange('panel9')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel9-content"
                        id="panel9-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.fundingSource?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Funding Source</Typography>
                            </Box>
                            {expanded === 'panel9' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.fundingSource;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={FundingSource.filter((c) => filters?.fundingSource?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={FundingSource}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    fundingSource: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Funding Source"
                                    name="Funding Source"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel10'} onChange={handleChange('panel10')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel10-content"
                        id="panel10-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.manufacturer?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Manufacturers</Typography>
                            </Box>
                            {expanded === 'panel10' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.manufacturer;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={manufacturerData.filter((c) => filters?.manufacturer?.includes(c.product_provider_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={manufacturerData}
                            getOptionLabel={(option) => option?.name}
                            ListboxProps={{
                                onScroll: (event) => loadNextManufacturer(event),
                            }}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    manufacturer: newValue.map((a) => a.product_provider_id),
                                }));
                                setManufacturerPage(1);
                            }}
                            inputValue={manInputValue === 0 || manInputValue === 'on' ? '' : manInputValue}
                            onInputChange={(e) => {
                                if (e) {
                                    setManInputValue(e.target.value);
                                    if (e?.target?.value?.length >= 1) {
                                        setManufacturerPage(1);
                                        getManufacturerData(1, e?.target?.value);
                                    }
                                }
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Manufacturer"
                                    name="Manufacturer"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {manufacturerLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel11'} onChange={handleChange('panel11')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel11-content"
                        id="panel11-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.furnish?.length > 0 || filters?.install?.length > 0) && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Responsibility</Typography>
                            </Box>
                            {expanded === 'panel11' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.furnish;
                                            delete obj.install;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={Responsibility.filter((c) => filters?.furnish?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={Responsibility}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    furnish: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Furnish Responsibility"
                                    name="Furnish Responsibility"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                        <br />
                        <Autocomplete
                            value={Responsibility.filter((c) => filters?.install?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={Responsibility}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    install: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Install Responsibility"
                                    name="Install Responsibility"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel12'} onChange={handleChange('panel12')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel12-content"
                        id="panel12-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.spatially && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Spatially Significant</Typography>
                            </Box>
                            {expanded === 'panel12' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.spatially;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.spatially === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        spatially: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.spatially === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        spatially: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel13'} onChange={handleChange('panel13')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel13-content"
                        id="panel13-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.stage?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Stage</Typography>
                            </Box>
                            {expanded === 'panel13' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.stage;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={ActionStage.filter((c) => filters?.stage?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={ActionStage}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    stage: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Stage"
                                    name="Stage"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel14'} onChange={handleChange('panel14')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel14-content"
                        id="panel14-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.productType?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Status</Typography>
                            </Box>
                            {expanded === 'panel14' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.status;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={ItemStatus.filter((c) => filters?.status?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={ItemStatus}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    status: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Status"
                                    name="Status"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel15'} onChange={handleChange('panel15')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel15-content"
                        id="panel15-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.productType?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Type</Typography>
                            </Box>
                            {expanded === 'panel15' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.productType;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={ProductType.filter((c) => filters?.productType?.includes(c.value)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={ProductType}
                            getOptionLabel={(option) => option?.name}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    productType: newValue.map((a) => a.value),
                                }));
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Type"
                                    name="Type"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel16'} onChange={handleChange('panel16')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel16-content"
                        id="panel16-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.vendors?.length > 0 && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Vendors</Typography>
                            </Box>
                            {expanded === 'panel16' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.vendors;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Autocomplete
                            value={vendorData.filter((c) => filters?.vendors?.includes(c.product_provider_id)) || []}
                            id="checkboxes-tags-demo"
                            size="small"
                            fullWidth
                            multiple
                            clearIcon={true}
                            disableCloseOnSelect
                            options={vendorData}
                            getOptionLabel={(option) => option?.name}
                            ListboxProps={{
                                onScroll: (event) => loadNextVendor(event),
                            }}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option.name}
                                    </li>
                                );
                            }}
                            onChange={(event, newValue) => {
                                setFilters((prevData) => ({
                                    ...prevData,
                                    vendors: newValue.map((a) => a.product_provider_id),
                                }));
                                setVendorPage(1);
                            }}
                            inputValue={inputValue === 0 || inputValue === 'on' ? '' : inputValue}
                            onInputChange={(e) => {
                                if (e) {
                                    setInputValue(e.target.value);
                                    if (e?.target?.value?.length >= 1) {
                                        setVendorPage(1);
                                        getVendorData(1, e?.target?.value);
                                    }
                                }
                            }}
                            renderInput={(params) =>
                                <TextField
                                    fullWidth
                                    {...params}
                                    label="Vendor"
                                    name="Vendor"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        endAdornment: (
                                            <>
                                                {vendorLoading ? <CircularProgress color="primary" size={20} /> : null}
                                                {params.InputProps.endAdornment}
                                            </>
                                        ),
                                    }}
                                />}
                        />
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel17'} onChange={handleChange('panel17')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel17-content"
                        id="panel17-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {filters?.inventoryid && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">Inventory ID</Typography>
                            </Box>
                            {expanded === 'panel17' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.inventoryid;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.inventoryid === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        inventoryid: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.inventoryid === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        inventoryid: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
                <Accordion expanded={expanded === 'panel18'} onChange={handleChange('panel18')}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="panel18-content"
                        id="panel18-header"
                    >
                        <Box display="flex" alignItems="center" justifyContent="space-between" style={{ width: '100%' }}>
                            <Box display="flex" alignItems="center">
                                {(filters?.isDeleted === 'yes' || filters?.isDeleted === 'no') && (
                                    <CheckIcon color="primary" />
                                )}
                                <Typography component="span">InActive Items</Typography>
                            </Box>
                            {expanded === 'panel18' && (
                                <Tooltip title="Remove Filter">
                                    <CloseIcon
                                        style={{ color: "gray", cursor: 'pointer', marginRight: 8 }}
                                        onClick={() => {
                                            const obj = filters;
                                            delete obj.isDeleted;
                                            setFilters(obj);
                                            setExpanded(false);
                                        }}
                                        fontSize="20"
                                    />
                                </Tooltip>
                            )}
                        </Box>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Box style={{ display: 'flex', gap: 5 }}>
                            <FixedButton
                                variant={filters?.isDeleted === 'yes' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'yes'
                                    }));
                                }}
                            >
                                Yes
                            </FixedButton>
                            <FixedButton
                                variant={filters?.isDeleted === 'no' ? 'contained' : 'outlined'}
                                onClick={() => {
                                    setFilters((prevData) => ({
                                        ...prevData,
                                        isDeleted: 'no'
                                    }));
                                }}
                            >
                                No
                            </FixedButton>
                        </Box>
                    </AccordionDetails>
                </Accordion>
            </FilterContent>
            <FilterFooter>
                <FixedButton variant="outlined" color="secondary" onClick={() => {
                    applyFilter({});
                    setFilters({});
                    setExpanded(false);
                    localStorage.removeItem('itemfilters');
                }}>Clear</FixedButton>
                <FixedButton variant="outlined" color="primary" onClick={() => handleFilter()}>Apply</FixedButton>
            </FilterFooter>
        </CustomFilterPanelWrapper>
    )
}